<template>
  <UiProductCard
    v-element-visibility="(isVisibility) => isVisibility && emits('visible')"
    :card="computedCard"
    @click="$emit('click')"
    @click:tooltip="handleTooltipClick"
  />
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { vElementVisibility } from '@vueuse/components'

  import UiProductCard from '@academica-box/components/Cards/UiProductCard/UiProductCard.vue'

  import type { Card } from '@academica-box/components/Cards/UiProductCard/types'

  import { useSubscribesStore } from '@academica-box/composables/store/subscribes'

  const config = useRuntimeConfig()

  const viewport = useViewport()
  const isDesktop = computed(() => viewport.isGreaterOrEquals('lg'))

  const subscribesStore = useSubscribesStore()
  const { isUserSubscriptionActive } = storeToRefs(subscribesStore)

  const props = defineProps<{
    card: Card;
  }>()

  const emits = defineEmits([
    'click',
    'visible'
  ])

  const computedCard = computed(() => {
    return {
      ...props.card,
      link: `/course${props.card.link}`,
      isSubscribeAvailable: props.card.isSubscribeAvailable && isUserSubscriptionActive.value
    }
  })

  const handleTooltipClick = () => {
    if (isDesktop.value) {
      if (!isUserSubscriptionActive.value) {
        location.href = `${config.public.frontUrl}/pro`
      } else {
        location.href = `${config.public.frontUrl}/catalog/?is_subscribe_available=1`
      }
    }
  }
</script>
